const Bluetooth = () => (
  <svg width="71" height="70" viewBox="0 0 71 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.9922 26.4246L37.7551 43.5766L27.3736 52.1525V17.8486L37.7551 26.4246L16.9922 43.5766"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M49.0786 44.9305C51.577 42.3145 53.1016 38.8283 53.1016 35.0004C53.1016 31.1725 51.577 27.6863 49.0786 25.0703M45.6863 28.3219C47.3214 30.1028 48.3132 32.4405 48.3132 35.0005C48.3132 37.5604 47.3214 39.8981 45.6863 41.6791M42.3037 38.3989C43.0687 37.4624 43.5248 36.2825 43.5248 35.0004C43.5248 33.6989 43.0548 32.5027 42.2688 31.5596"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Bluetooth;
